export const SWAP_120L = "SWP_120L";
export const SWAP_240L = "SWP_240L";
export const SWAP_360L = "SWP_360L";

export const DELIVER_120L = "Deliver 120L";
export const DELIVER_240L = "Deliver 240L";
export const DELIVER_NEW_CART = "Deliver New Service";
export const DELIVER_120L_TRASH = "120 LiterTrash";
export const DELIVER_240L_TRASH = "240 LiterTrash";
export const ORGANICS_120L = "120 LiterOrganics";
export const FOOD_SCRAP_CART = "Food Scrap Cart (Organics)";

export const SELECT_A_NEW_CART = "SELECT MY NEW CART";

export const COMMENT_OTHER_SERIALNUMBER_SPLIT = "Serial Number - ";